export interface HoursWorked {
  hw: number;
  st: number;
  ot: number;
  pt: number;
  pd: number;
  trv: number;
  vac: number;
  /**
   * Sick hours. Optional because `bulk-labor-entry` deliberately does not offer
   * a sick field (a bulk crew edit is never "everyone was out sick on the same
   * job"), and `updateEmployeeLabors` iterates `Object.keys`, so an absent key
   * leaves any existing SICK labor untouched while `sick: 0` deactivates it.
   * Those are different outcomes and the optionality is what keeps them apart.
   */
  sick?: number;
  hol: number;
}
